module.exports = __webpack_public_path__ + "media/images/pdf-icon-b580ecd8.png";